import { render } from "./Loading.vue?vue&type=template&id=36a4b4ff&scoped=true"
import script from "./Loading.vue?vue&type=script&lang=js"
export * from "./Loading.vue?vue&type=script&lang=js"

import "./Loading.vue?vue&type=style&index=0&id=36a4b4ff&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-36a4b4ff"

export default script